import React, { ReactElement } from 'react';
import { useRouter } from 'next/router';
import { ResponsiveRender } from '@pb/shared/ui/atoms/responsive-render';
import { Icon } from '@pb/shared/ui/atoms/icon';
import { TStep, TStepperProperties } from './stepper.types';
import {
    StyledActionNeededIcon,
    StyledActionNeededStepName,
    StyledContainer,
    StyledCurrentStepIcon,
    StyledCurrentStepName,
    StyledStepContainer,
    StyledFutureStepName,
    StyledFutureStepNumber,
    StyledSuccessIcon,
    StyledSuccessStepName,
    StyledSteps,
} from './stepper.styled';
import { StepperAccordion } from '../../../stepper-accordion/src';

export function Stepper({ steps }: TStepperProperties): ReactElement {
    const router = useRouter();

    function renderCorrectStylingForIcon(step: TStep, stepNumber: number) {
        if (step.position === 'Previous' && step.isComplete) {
            return (
                <StyledSuccessIcon>
                    <Icon type="tick" color="white" />
                </StyledSuccessIcon>
            );
        }
        if (step.position === 'Previous' && !step.isComplete) {
            return <StyledActionNeededIcon>!</StyledActionNeededIcon>;
        }
        if (step.position === 'Current') {
            return <StyledCurrentStepIcon>{stepNumber}</StyledCurrentStepIcon>;
        }
        return <StyledFutureStepNumber>{stepNumber}</StyledFutureStepNumber>;
    }
    function renderCorrectStylingForStepName(step: TStep) {
        if (step.position === 'Previous' && step.isComplete) {
            return <StyledSuccessStepName>{step.name}</StyledSuccessStepName>;
        }
        if (step.position === 'Previous' && !step.isComplete) {
            return (
                <StyledActionNeededStepName>
                    {step.name}
                </StyledActionNeededStepName>
            );
        }
        if (step.position === 'Current') {
            return <StyledCurrentStepName>{step.name}</StyledCurrentStepName>;
        }
        return <StyledFutureStepName>{step.name}</StyledFutureStepName>;
    }
    return (
        <>
            <ResponsiveRender showOnBreakpoints={['xs', 's']}>
                <StepperAccordion steps={steps} />
            </ResponsiveRender>
            <ResponsiveRender showOnBreakpoints={['m', 'l', 'xl']}>
                <StyledContainer>
                    <StyledSteps>
                        {steps &&
                            steps.map((step, index) => {
                                const stepNumber = index + 1;
                                return (
                                    <StyledStepContainer
                                        key={`${stepNumber}-${step.name}`}
                                        onClick={() => {
                                            if (step.position === 'Previous') {
                                                router.push(step.asPath);
                                            }
                                        }}
                                        position={step.position}
                                    >
                                        {renderCorrectStylingForIcon(
                                            step,
                                            stepNumber
                                        )}
                                        {renderCorrectStylingForStepName(step)}
                                    </StyledStepContainer>
                                );
                            })}
                    </StyledSteps>
                </StyledContainer>
            </ResponsiveRender>
        </>
    );
}
